<template>
    <div class="wrapper limit">
        <div class="pand"></div>
        <div class="info">
            <div class="info-wrap">
                <img src="~@/assets/wijwetendingen_logo_white.png" class="logo" />

                <b>{{ $t('misc.part_of_wdd_group') }}</b>

                <a href="https://wijdoendingen.nl">www.wijdoendingen.nl</a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    mounted() {},

    components: {}
};
</script>

<style scoped lang="scss">
.wrapper {
    width: 100%;

    min-height: 550px;

    display: grid;
    grid-template-columns: 2fr 1fr;
    @media screen and (max-width: 950px) {
        grid-template-columns: 1fr;
    }

    background-color: black;

    .pand {
        background-image: url($asset_pand);
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;

        @media screen and (max-width: 950px) {
            min-height: 550px;
        }
    }

    .info {
        padding: 50px;
        width: 100%;

        display: flex;
        justify-content: center;
        align-items: flex-start;

        .info-wrap {
            display: flex;
            flex-direction: column;
        }

        img {
            max-width: 300px;
            margin-bottom: 30px;
        }

        b {
            color: white;
            font-weight: bold;

            text-transform: uppercase;
        }

        a {
            color: white;
            font-weight: normal;
            margin-top: 30px;
            text-transform: uppercase;
        }

        color: white;
    }
}
</style>
